export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50 pt-14 md:pt-20 pb-8">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <span
              className="inline-block text-2xl font-black mb-4"
              style={{ fontFamily: "'ZCOOL KuaiLe', cursive" }}
            >
              酷看漫画
            </span>
            <p className="text-sm text-background-50/60 leading-relaxed">
              酷看漫画将韩漫、日漫、国漫分类整理，更汇集玄幻、恋爱、热血等热门类型。免费在线阅读，找好看的漫画一搜即达。每日更新数百话，为漫画爱好者打造优质阅读平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors no-underline cursor-pointer">首页</a>
              <a href="#ranking" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors no-underline cursor-pointer">排行榜</a>
              <a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors no-underline cursor-pointer">专题合集</a>
              <a href="#faq" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors no-underline cursor-pointer">常见问题</a>
              <a href="#updates" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors no-underline cursor-pointer">更新动态</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">漫画分类</h4>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-50/70 whitespace-nowrap">韩漫</span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-50/70 whitespace-nowrap">日漫</span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-50/70 whitespace-nowrap">国漫</span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-50/70 whitespace-nowrap">玄幻</span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-50/70 whitespace-nowrap">恋爱</span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-50/70 whitespace-nowrap">热血</span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-50/70 whitespace-nowrap">悬疑</span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-50/70 whitespace-nowrap">穿越</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40">更多合作伙伴即将入驻，敬请期待。</p>
          </div>
        </div>

        <div className="pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 酷看漫画 - 韩漫日漫国漫分类大全。本站所有内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors no-underline cursor-pointer">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}